import React from 'react';

import PropTypes from 'prop-types';

import { Tabs as ShadcnTabs } from '@/components/ui/tabs';
import { iconShape } from '../../../../shared/types';
import TabsControl from './TabsControl';
import TabsView from './TabsView';

const Tabs = ({ config }) => (
  <ShadcnTabs className="h-full" defaultValue={config[0].value}>
    <TabsControl config={config} />
    <TabsView config={config} />
  </ShadcnTabs>
);

Tabs.propTypes = {
  config: PropTypes.arrayOf(
    PropTypes.shape({
      component: PropTypes.elementType.isRequired,
      icon: iconShape.isRequired,
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default Tabs;
